import React, { useState } from "react";
import Card from "./card";
import Rbpi from "./rbpi";

const Tabs = ({ selectedStudent, pin, onStatusChange }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="tabs-container w-full h-full bg-white rounded-md shadow-lg p-4 mr-1">
      <div className="tabs-header flex justify-start space-x-4 border-b pb-2">
        <button
          onClick={() => setActiveTab(0)}
          className={`px-4 py-2 ${
            activeTab === 0 ? "border-b-2 border-orange-500 font-bold text-orange-600" : "text-gray-600"
          }`}
        >
          Student Details
        </button>
        <button
          onClick={() => setActiveTab(1)}
          className={`px-4 py-2 ${
            activeTab === 1 ? "border-b-2 border-orange-500 font-bold text-orange-600" : "text-gray-600"
          }`}
        >
          License Plate Detection
        </button>
      </div>

      <div className="tabs-content mt-4">
        {activeTab === 0 ? (
          selectedStudent ? (
            <Card
              student={selectedStudent}
              pin={pin}
              onStatusChange={onStatusChange}
            />
          ) : (
            <p className="text-gray-500">Select a student from the sidebar.</p>
          )
        ) : (
          <Rbpi onStatusChange={onStatusChange} />
        )}
      </div>
    </div>
  );
};

export default Tabs;